export default __webpack_public_path__ + "static/media/8ea02a9276b95809115d3899b62cfb76.jpg";